import { Box } from '@mui/material';
import React, { useState } from 'react'
import { Container, Row } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom';

const BlogWarehouse = () => {


    const RecentBlog = [
        {
            img: './assets/images/blog-detail-1.png',
            title: 'Is slower team communication a bad thing?',
            date: '4 March 2024',
            path: '/blog-detail'
        },
        {
            img: './assets/images/blog-detail-2.png',
            title: 'Is slower team communication a bad thing?',
            date: '23 March 2024',
            path: '/blog-detail'
        },
        {
            img: './assets/images/blog-detail-3.png',
            title: 'The Power of Smart Warehouse Management System in 2024',
            date: '14 March 2024',
            path: '/blog-detail'
        },
        {
            img: './assets/images/blog-detail-1.png',
            title: 'Is slower team communication a bad thing?',
            date: '8 March 2024',
            path: '/blog-detail'
        },
    ]

    const blogTag = [
        {
            tagTitle: 'Development',
            path: '/DevelopBlogList'
        },
        {
            tagTitle: 'Technology',
            path: '/TechBlogList'
        },
        {
            tagTitle: 'HTML',
            path: '/HtmlBlogList'
        },
        {
            tagTitle: 'Branding',
            path: '/BrandBlogList'
        },
        {
            tagTitle: 'PHP',
            path: '/PhpBlogList'
        }
    ]


    const [searchQuery, setSearchQuery] = useState('');
    const navigate = useNavigate(); // Hook for programmatic navigation

    // Handle the search input change
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };

    // Handle form submission (search on Enter key press)
    const handleSearchSubmit = (e) => {
        e.preventDefault();

        // Filter the tags based on the search query
        const filteredTags = blogTag.filter((tag) =>
            tag.tagTitle.toLowerCase().includes(searchQuery.toLowerCase())
        );

        const filteredBlogs = RecentBlog.filter((blog) =>
            blog.title.toLowerCase().includes(searchQuery.toLowerCase())
        );

        // Navigate to the search results page with the filtered data
        navigate('/noBlog', {
            state: { searchQuery, filteredTags, filteredBlogs },
        });
    };

    return (
        <>
            
            {/* Blog Detail Banner */}
            <section className='blog-detail-page'>
                <div className='blog-detail-bg'>    
                    <div className='c-detail-shap-1 blog-det-1'>
                        <img src="../assets/images/whi-5.svg" alt="" />
                    </div>
                    <div className='blog-detail-shap-1 blog-det-1'>
                        <img src="../assets/images/whi-2.svg" alt="" />
                    </div>
                    <div className='about-shap-3 blog-det-1'>
                        <img src="../assets/images/about-shap-1.png" alt="" />
                    </div>
                    <div className='about-shap-4 blog-det-1'>
                        <img src="../assets/images/about-shap-2.png" alt="" />
                    </div>
                    <div className='about-shap-5 blog-det-1'>
                        <img src="../assets/images/about-shap-3.svg" alt="" />
                    </div>
                    <Container>
                        <div className='row justify-content-center'>
                            <div className='col-xl-12 col-lg-10 col-md-11 col-sm-11 col-11 col-padding'>
                                <div className='blogdetail-content' data-aos="fade-right" data-aos-duration="2000">
                                    <h3>Why Cross-Platform Mobile Apps Are the Future</h3>
                                    <h6>15 April 2025</h6>
                                </div>
                            </div>
                        </div>
                    </Container>
                </div>
            </section>
        
            <div className='blog-detail-position'>
                <Container>
                    <div className='row justify-content-center'>
                        <div className='col-xl-12 col-lg-10 col-md-11 col-sm-11 col-11' data-aos="zoom-in-up" data-aos-duration="2500">
                            <div className='blog-detail-1'>
                                <img src="../assets/images/blog_2.png" alt="" />
                            </div>
                        </div>
                    </div>
    
                    <div className='blog-detail-padding'>
                        <Row>
                            <div className="col-xl-8 col-lg-7">

                                <p className='blog-para'>In a world where mobile devices are the primary gateway to digital experiences, businesses need to reach users on both Android and iOS without doubling the development effort. Cross-platform mobile app development has emerged as a powerful solution—offering a single codebase that works across platforms while ensuring native-level performance and a seamless user experience. </p>

                                <div className='blog-detail-content-1' data-aos="fade-right" data-aos-duration="1500">
                                    <h3>Efficiency and Cost Savings  </h3>
                                    <p>One of the primary benefits of cross-platform development is cost efficiency. Rather than hiring separate teams for Android and iOS development, businesses can work with a single team and one unified codebase. This significantly reduces development and maintenance costs, making it ideal for startups and SMEs with limited budgets. </p>
                                </div>

                                <div className='blog-detail-content-1' data-aos="fade-right" data-aos-duration="1650">
                                    <h3>Faster Time to Market </h3>
                                    <p>Cross-platform tools such as Flutter, React Native, and Xamarin allow for rapid development cycles. Code can be reused across platforms, cutting down on testing and deployment time. For businesses in fast-paced markets, this means being able to launch products quicker and respond to user feedback faster. </p>
                                </div>
                                
                                <div className='blog-detail-content-1' data-aos="fade-right" data-aos-duration="1800">
                                    <h3>Consistency in User Experience </h3>
                                    <p>A consistent look and feel across platforms is critical for brand identity. Cross-platform development ensures that UI components and functionality behave similarly on all devices. This results in a smoother and more intuitive experience for users, regardless of their device.  </p>
                                </div>

                                <div className='blog-detail-content-1' data-aos="fade-right" data-aos-duration="1950">
                                    <h3>Easier Maintenance and Updates </h3>
                                    <p>With a unified codebase, updates and bug fixes are deployed simultaneously to both Android and iOS. This not only speeds up delivery but also reduces the chances of inconsistent features or performance issues across platforms. </p>
                                </div>

                                <div className='blog-detail-content-1' data-aos="fade-right" data-aos-duration="2100">
                                    <h3>Broader Reach  </h3>
                                    <p>Deploying your app on both platforms maximizes your user base. With global Android usage dominating in many regions and iOS leading in others, cross-platform apps ensure no user is left out. </p>
                                    <p>As tools continue to evolve and performance gaps with native apps shrink, cross-platform development is quickly becoming the default choice for modern mobile applications—delivering quality, speed, and value. </p>
                                </div>

                            </div>
                            <div className="col-xl-4 col-lg-5 mt-30">
                                <div className='ml-lg-30 ml-0'>
                                    <div className=' mb-20' data-aos="fade-up-left" data-aos-duration="3000">
                                        <div className='search-border'>
                                            <h4>Search</h4>
                                            <form className='search-box position-relative' onSubmit={handleSearchSubmit}>
                                                <input className='w-100' placeholder='Search Your Keywords…' type="text" value={searchQuery}  onChange={handleSearchChange} />
                                                <button className='search-icon' type="submit">
                                                    <img src="../assets/images/search-icon.svg" alt="" />
                                                </button>
                                            </form>
                                        </div>
                                    </div>


                                    <div className=' mb-20' data-aos="fade-up-left" data-aos-duration="2500">
                                        <div className='blog-border'>
                                            <h4>Recent Blog</h4>
                                            <div className='border-blog'></div>
                                            <ul>
                                                {RecentBlog.map((blog, index) => (
                                                    <li key={index}>
                                                        <Link to={blog.path}>
                                                            <Box sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '13px'
                                                            }}>
                                                                <div className='blog-list-img'>
                                                                    <img src={blog.img} alt="" />
                                                                </div>
                                                                <div className='blog-list-text'>
                                                                    <h6>{blog.title}</h6>
                                                                    <p>{blog.date}</p>
                                                                </div>
                                                            </Box>
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>

                                    <div className='blog-border' data-aos="fade-up-left" data-aos-duration="2000">
                                        <h4>Tag Cloud</h4>
                                        <div className='border-blog'></div>
                                        
                                        <Box sx={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            gap: '10px'
                                        }}>
                                            {
                                                blogTag.map((tag,index) => (
                                                    <Link key={index} to={tag.path}>
                                                        <p className="tag-badge">{tag.tagTitle}</p>
                                                    </Link>
                                                ))
                                            }
                                        </Box>
                                        
                                    </div>
                                </div>
                            </div>
                        </Row>
                    </div>
                </Container>
            </div>
            
        </>
    )
}

export default BlogWarehouse
